import { useSettingsStore } from '@/store';
import { AppConfigTypes } from '@/types/appConfigTypes';

export const useThemeConfig = () => {
  const {
    lightThemeColors,
    darkThemeColors,
    themeMode,
    settings,
    setSettings,
    setThemeMode,
    setHexColors,
  } = useSettingsStore();

  const setAppConfig = (data: AppConfigTypes) => {
    setSettings(data);
    setThemeMode('light')

    // if (data?.ui?.theming?.themeMode !== 'auto') {
    //   setThemeMode(data?.ui?.theming?.themeMode || 'auto');
    // }

    const primaryLight = data?.ui?.theming?.colors?.primary?.light;
    const secondaryLight = data?.ui?.theming?.colors?.secondary?.light;
    const primaryDark = data?.ui?.theming?.colors?.primary?.dark;
    const secondaryDark = data?.ui?.theming?.colors?.secondary?.dark;

    setHexColors({
      primaryLight,
      secondaryLight,
      primaryDark,
      secondaryDark,
    });







    // setLightThemeColors({
    //   '--primary': lightPrimaryHsl,
    //   '--ring': lightPrimaryHsl,
    //   '--secondary': lightSecondaryHsl,
    //   '--primary-foreground': lightPrimaryForegroundHsl,
    //   '--secondary-foreground': lightSecondaryForegroundHsl,
    // });
    // setDarkThemeColors({
    //   '--primary': darkPrimaryHsl,
    //   '--ring': darkPrimaryHsl,
    //   '--secondary': darkSecondaryHsl,
    //   '--primary-foreground': darkPrimaryForegroundHsl,
    //   '--secondary-foreground': darkSecondaryForegroundHsl,
    // });
  };

  return {
    setAppConfig,
    lightThemeColors,
    darkThemeColors,
    themeMode,
    settings,
    setThemeMode,
  };
};
